var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { List as RaList, downloadCSV, useResourceContext, usePermissions, } from 'react-admin';
import jsonExport from 'jsonexport/dist';
import { ListActions } from './ListActions';
import { canAccess } from '../canAccess';
/**
 * Replacement for react-admin's List that adds RBAC control to actions
 *
 * Users must have the 'create' permission on the resource to see the `<CreateButton>`.
 * Users must have the 'export' permission on the resource to see the `<ExportButton>`.
 * Users must have the 'read' permission on a resource column to see it in the export.
 *
 * @example
 * import { List } from '@react-admin/ra-rbac';
 *
 * const authProvider = {
 *     // ...
 *     getPermissions: () =>
 *         Promise.resolve([
 *             { action: 'list', resource: 'products' },
 *             { action: 'export', resource: 'products' },
 *             // actions 'create' and 'delete' are missing
 *             { action: 'read', resource: 'products.name' },
 *             { action: 'read', resource: 'products.description' },
 *             { action: 'read', resource: 'products.price' },
 *             { action: 'read', resource: 'products.category' },
 *             // resource 'products.stock' is missing
 *         ]),
 * };
 *
 * export const PostList = () => (
 *     <List>
 *         ...
 *     </List>
 * );
 * // Users will see the Export action on top of the list, but not the Create action.
 * // Users will only see the authorized columns when clicking on the export button.
 */
export var List = function (props) {
    var _a;
    var resource = useResourceContext(props);
    var _b = usePermissions(), isLoading = _b.isLoading, permissions = _b.permissions;
    if (isLoading) {
        return null;
    }
    var defaultExporter = function (records) {
        var recordsWithAuthorizedColumns = records.map(function (record) {
            return Object.keys(record)
                .filter(function (key) {
                return canAccess({
                    permissions: permissions,
                    action: 'read',
                    resource: "".concat(resource, ".").concat(key),
                });
            })
                .reduce(function (obj, key) {
                var _a;
                return (__assign(__assign({}, obj), (_a = {}, _a[key] = record[key], _a)));
            }, {});
        });
        jsonExport(recordsWithAuthorizedColumns, function (err, csv) {
            return downloadCSV(csv, resource);
        });
    };
    var exporter = props.exporter === false ? false : (_a = props.exporter) !== null && _a !== void 0 ? _a : defaultExporter;
    return (React.createElement(RaList, __assign({ actions: React.createElement(ListActions, { exporter: exporter }), exporter: exporter }, props)));
};
List.propTypes = RaList.propTypes;
